// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import icons from "../../../icons.config";
// import { IMAGE_BASE_URL } from "../../../api-urls";

// const Blogs = ({ data }) => {
//   const initialImages = data?.map((item) => ({
//     image: item.thumbnail,  // ✅ Correctly accessing 'thumbnail'
//     alt: item.title,
//     description: item.blog,
//     cImage: item.thumbnail,
//   })) || []; // Fallback to an empty array if 'data' is undefined
  

//   const [imageList, setImageList] = useState(initialImages);
//   const [activeImageIndex, setActiveImageIndex] = useState(initialImages.length - 1);
//   const [isFading, setIsFading] = useState(false);

//   const fadeVariants = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1, transition: { duration: 0.3 } },
//     exit: { opacity: 0, transition: { duration: 0.5 } },
//   };

//   const handleImageClick = (clickedIndex) => {
//     const newImageList = [...imageList];
//     const bigImage = newImageList[activeImageIndex];
//     const clickedImage = newImageList.splice(clickedIndex, 1)[0];
//     newImageList.splice(activeImageIndex, 1);

//     const clickedImageWithCImage = {
//       ...clickedImage,
//       image: clickedImage.cImage,
//     };

//     newImageList.splice(activeImageIndex, 0, clickedImageWithCImage);
//     newImageList.push(bigImage);

//     setImageList(newImageList);
//   };

//   const navigate = useNavigate();
//   const goToBlogs = () => {
//     navigate("/blogs");
//   };

//   return (
//     <section className="overflow-hidden bg-tertiary">
//       <div className="flex flex-col lg:flex-row lg:space-x-8 py-0 px-6 lg:px-20">
//         <div className="lg:w-1/2 relative">
//           <h2 className="text-5xl font-outfit font-light text-primary1 mb-6 text-center lg:text-left">
//             BLOGS
//           </h2>
//           <p className="text-sm text-[#650D1B] font-poppins font-light mb-8">
//             Explore the latest collections, discover tips, and stay updated with trending styling tips and expert advice.
//           </p>
//           <div className="hidden lg:grid grid-cols-2 gap-4">
//             {imageList.slice(0, 4).map((img, index) => (
//               <motion.div key={index} className="cursor-pointer" onClick={() => handleImageClick(index)}>
//                 <motion.img src={IMAGE_BASE_URL+img.image} alt={img.alt} className="w-full h-auto" />
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         <div className="lg:w-1/2 relative">
//           <motion.div key={activeImageIndex} variants={fadeVariants} initial="hidden" animate="visible" exit="exit">
//             <img src={IMAGE_BASE_URL+imageList[activeImageIndex].image} alt={imageList[activeImageIndex].alt} className="w-full h-auto" />
//             <div className="absolute bg-red-opacity-80 p-4">
//               <h3 className="text-primary1 text-3xl font-outfit font-light">{imageList[activeImageIndex].alt}</h3>
//               <p className="text-hcolor text-xs font-poppins font-normal">{imageList[activeImageIndex].description}</p>
//             </div>
//             <div className="cursor-pointer" onClick={goToBlogs}>
//               <img src={icons.blogArrow} alt="Arrow Icon" className="w-9 h-9" />
//             </div>
//           </motion.div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Blogs;



import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import images from '../../../images.config';
import icons from "../../../icons.config";
import { IMAGE_BASE_URL } from "../../../api-urls";

const Blogs = ({data}) => {
  // const initialImages = [
  //   { image: images.blog1, alt: "IMAGE 1" , description:"first image description", cImage:images.blog1c},
  //   { image: images.blog2, alt: "Image 2", description:"second image description", cImage:images.blog2c},
  //   { image: images.blog3, alt: "Image 3",description:"third image description" , cImage:images.blog3c},
  //   { image: images.blog4, alt: "Image 4",description:"fourth image description" , cImage:images.blog4c},
  //   { image: images.blog5, alt: "Big Image",description:"fifth image description", cImage:images.blog5c}, // Initial big image
  // ];





const initialImages = data?.map((item) => ({
  image: item.thumbnail,  // ✅ Correctly accessing 'thumbnail'
  alt: item.title,
  description: item.blog,
  cImage: item.thumbnail,
})) || []; // Fallback to an empty array if 'data' is undefined








  // const [imageList, setImageList] = useState(initialImages);
  //  const [currentIndex, setCurrentIndex] = useState(0);
  // const [activeImageIndex, setActiveImageIndex] = useState(4); // Index of the big image initially
  // const [isFading, setIsFading] = useState(false); // State for fade effect





const [currentIndex, setCurrentIndex] = useState(0);
const [imageList, setImageList] = useState(initialImages);
const [activeImageIndex, setActiveImageIndex] = useState(initialImages.length - 1);
const [isFading, setIsFading] = useState(false);



  const fadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.3 } },
    exit: { opacity: 0, transition: { duration: 0.5 } },
  };

// };
// const handleImageClick = (clickedIndex) => {
//   const newImageList = [...imageList]; // Copy the current image list

//   // Get the currently active big image
//   const bigImage = newImageList[activeImageIndex];

//   // Remove the clicked image from its current position
//   const clickedImage = newImageList.splice(clickedIndex, 1)[0]; // Remove and store the clicked image

//   // Remove the big image from its current position
//   newImageList.splice(activeImageIndex, 1); // Remove the big image from its current position

//   // Create a new object for the clicked image using its 'cImage' for the big image
//   const clickedImageWithCImage = {
//     ...clickedImage, // Keep all the properties the same
//     image: clickedImage.cImage, // Use the cImage as the new big image
//   };

//   // Insert the clicked image with its cImage as the new big image
//   newImageList.splice(activeImageIndex, 0, clickedImageWithCImage); // Insert at the big image's position

//   // Add the previous big image back into the list, reverting its image back to original
//   const originalBigImage = {
//     ...bigImage, // Keep all properties the same
//     image: bigImage.image, // Ensure it reverts to its original image
//   };
//   newImageList.push(originalBigImage); // Add the old big image to the last position

//   // Update the state
//   setImageList(newImageList);
//   setActiveImageIndex(activeImageIndex); // Keep the active index the same for now
// };







const handleImageClick = (clickedIndex) => {
  const newImageList = [...imageList];
  const bigImage = newImageList[activeImageIndex];
  const clickedImage = newImageList.splice(clickedIndex, 1)[0];
  newImageList.splice(activeImageIndex, 1);

  const clickedImageWithCImage = {
    ...clickedImage,
    image: clickedImage.cImage,
  };

  newImageList.splice(activeImageIndex, 0, clickedImageWithCImage);
  newImageList.push(bigImage);

  setImageList(newImageList);
};
const navigate=useNavigate();
  const goToBlogs=()=>{
    navigate("/blogs");
   }

  return (
    <section className="overflow-hidden bg-tertiary " >
      <div className="left-0 bottom-12 lg:bottom-8 xl:bottom-20 relative">
        <img src={icons.blogCircles} alt="Doodle Left" className="w-40 lg:w-1/5" />
      </div>
      
    {/* <div className="flex flex-col lg:flex-row py-16 md:py-28 lg:py-0 px-6 lg:px-20 relative bottom-16 md:bottom-0 "> */}
      {/* Left Section */}
     
       {/* Main Container with Responsive Flex Layout */}
  <div className="flex flex-col lg:flex-row lg:space-x-8 py-0 px-6 lg:px-20 ">
  <div className="lg:w-1/2   relative ">
    
    {/* Left Section with Big Image on Top for Small and Medium Screens */}
    
      <div className="relative bottom-24 md:bottom-20 lg:bottom-14 px-3 lg:px-12 left-3 lg:left-1">
        <h2 className="text-5xl font-outfit font-light text-primary1 mb-6 text-center lg:text-left">
         BLOGS
        </h2>
        <p className="text-sm text-[#650D1B] font-poppins font-light mb-8 relative top-4 md:pr-2 lg:pr-0 ">
        {data.description || "Explore the latest collections, discover tips or find your perfect fit, and learn about luxurious fabrics . Stay inspired and updated with fresh insights, trending styling tips, expert advice and famous fashion stories to elevate your wardrobe and upgrade your style."}
        </p></div>
        
        
        {/* Small Images (2 per row, display only the first 4) */}
        <div className="hidden lg:grid grid-cols-2 gap-x-0 gap-y-8 xl:gap-y-10 relative lg:left-12 lg:-top-6 xl:-top-4 2xl:top-11 mx-1 left-4  lg:-mb-1 z-10" >
          {imageList.slice(0, 4).map((img, index) => (
            <motion.div
              key={index}
              className={`cursor-pointer ${isFading ? "opacity-0" : "opacity-100"} transition-opacity duration-500`} // Fade effect on small images
                onClick={() => handleImageClick(index)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
            >
              <motion.img
                src={IMAGE_BASE_URL+img.image}
                alt={img.alt}
                className="w-[85%] lg:w-[88%]  h-auto"
                
                initial="hidden"
                animate="visible"
                exit="exit"
              />
            </motion.div>
          ))}
        </div>
      </div>

      {/* Right Section with Big Image */}
      <div className="lg:w-1/2 relative -top-20 md:-top-14 lg:left-7  lg:-top-20 xl:-top-24  left-5 xl:left-3  md:flex md:flex-col  z-10">
        <motion.div
          key={activeImageIndex}
          className="relative"
          variants={fadeVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <img
            src={IMAGE_BASE_URL+imageList[activeImageIndex].image}
            alt={imageList[activeImageIndex].alt}
            className={`w-[90%] md:w-[95%] lg:w-[94%] h-[90%] lg:h-[190%] xl:h-[160%]  lg:py-5 2xl:pt-12 xl:w-[90%] object-cover transition-opacity duration-500 ${isFading ? "opacity-0" : "opacity-100"}`} // Apply fade effect on the big image
          />
          {/* Overlay Text */}
          <div 
                className="absolute flex flex-col items-start justify-end ml-2 mb-4 top-[60%] md:top-[80%] lg:top-[125%]  xl:top-[175%] 2xl:top-[136%] bg-red-opacity-80 z-20" 
                style={{ padding: '50px 16px', maxHeight: '20%',maxWidth:'50%' }} // Reduced padding and max height
              >
                <h3 className="text-primary1 text-3xl font-outfit font-light"> {/* Decreased font size */}
                  {imageList[activeImageIndex].alt}
                </h3>
                <p className="text-hcolor text-xs font-poppins font-normal mb-0">
  {imageList[activeImageIndex].description
    .split(" ")
    .slice(0, 20)
    .join(" ")}
  {imageList[activeImageIndex].description.split(" ").length > 20 ? "..." : ""}
</p>

                
              </div>

             {/* Arrow Icon */}
            <div className="relative flex flex-col items-end justify-end ml-6 right-[16%] bottom-16 lg:right-[14%] lg:bottom-[33%] 2xl:bottom-[22%] cursor-pointer">
            <img 
                src={icons.blogArrow} // Replace with your arrow icon path
                alt="Arrow Icon" 
                className=" w-6 h-6 lg:w-9 lg:h-9 " // Adjust width and height as needed
                onClick={goToBlogs}
              />
            </div>


        </motion.div>
      </div>
    </div>
    <div className="grid grid-cols-2 gap-4 lg:hidden relative bottom-14 md:bottom-0 px-10 z-10">
      {imageList.slice(0, 4).map((img, index) => (
        <motion.div
          key={index}
          className="cursor-pointer transition-opacity duration-500"
          onClick={() => handleImageClick(index)}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <motion.img
            src={IMAGE_BASE_URL+img.image}
            alt={img.alt}
            className="w-full h-[50%]"
            initial="hidden"
            animate="visible"
            exit="exit"
          />
        </motion.div>
      ))}
       
    </div>
    <div className="relative -top-24 md:-top-10  xl:top-12 2xl:-top-14 -right-[86%] md:-right-[90%] xl:-right-[86%] 2xl:-right-[87%] -bottom-[22%] xl:pb-12 2xl:pb-0">
            <img 
                src={icons.blogCirclesDown} // Replace with your arrow icon path
                alt="Arrow Icon" 
                className="w-24 lg:w-48 xl:w-52  " // Adjust width and height as needed
              />
            </div>
   
   
    
    
    </section>


  );
};

export default Blogs;


